import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { LabelWrapper, Wrapper } from './styled';
export const TableNote = React.memo(function TableNote({ label, value, dataTestId }) {
    if (!value) {
        return null;
    }
    return (_jsxs(Wrapper, { "data-testid": dataTestId, children: [_jsx(LabelWrapper, { children: label }), value] }));
});
